angular.module('pdf').factory('imageHandler', [
  '$q', 'File', 'API_ENDPOINT', 'SITE_URL',
  function ($q, File, API_ENDPOINT, SITE_URL) {
    class ImageHandler {
      prepareImages(attachments) {
        const promises = (attachments || [])
          .filter(attachment => attachment && File.isImage(attachment.metadata.attach_file_name))
          .map((imageAtt) => {
            const path = `/attachment/?file=${imageAtt.metadata.id}/${imageAtt.metadata.attach_file_name}`;
            return this.loadImage(path)
              .then(img => { imageAtt.image = img; })
              .catch(error => {
                console.error(`Failed to load image: ${path}`, error);
                return $q.resolve();
              });
          });
        return $q.all(promises);
      }

      loadImage(path, base = API_ENDPOINT, handleTransparency = false) {
        return $q((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = 'use-credentials';
          img.onload = () => {
            if (handleTransparency) {
              const newImg = this.redrawOnWhite(img);
              newImg.onload = () => resolve(newImg);
              newImg.onerror = reject;
            } else {
              resolve(img);
            }
          };
          img.onerror = reject;
          img.src = base + path;
        });
      }

      redrawOnWhite(img) {
        // Create a canvas element
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        
        // Draw a white rectangle, for transparency, since we compose PDF with white background
        ctx.fillStyle = 'white';
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        
        // Draw the image on top of the white rectangle
        ctx.drawImage(img, 0, 0);
        
        const dataURL = canvas.toDataURL();
        
        // Create a new Image element
        const newImg = new Image();
        newImg.src = dataURL;
        return newImg;
      }

      loadQrCode(practiceData) {
        if (practiceData.website) {
          return this.loadImage(`/qrcode?website=${practiceData.website}`)
            .then(img => { practiceData.qrCode = img; });
        }
        return $q.resolve();
      }

      loadCoBrandingImages(practiceData) {
        if (practiceData.logoUrl) {
          return this.loadImage(practiceData.logoUrl + '?t=1', SITE_URL, true)
            .then(img => { practiceData.logoImg = img; });
        } else {
          return $q.resolve();
        }
      }
    }

    return new ImageHandler();
  }
]);